import { render, staticRenderFns } from "./CustomTree.vue?vue&type=template&id=b00ca264&scoped=true&"
import script from "./CustomTree.vue?vue&type=script&lang=js&"
export * from "./CustomTree.vue?vue&type=script&lang=js&"
import style0 from "./CustomTree.vue?vue&type=style&index=0&id=b00ca264&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00ca264",
  null
  
)

export default component.exports